module.exports = __webpack_public_path__ + "static/media/congrats-bg.d8a8bb6f.svg";